
window.jQuery = window.$ = require('jquery');

require('bootstrap');

require('./inc-fontsize');
require('./inc-scroll');
require('./inc-header-search');

if(themeajax.debug){
    require('./inc-reload-css');
}

$(function() {

    $.expr[':'].external = function(obj){
        return !obj.href.match(/^mailto\:/)
               && (obj.hostname != location.hostname)
               && !obj.href.match(/^javascript\:/)
               && !obj.href.match(/^$/)
    };

    $('a:external').attr('target', '_blank');

    $('.site-header-menu-toggle').click(function(e){
        e.preventDefault();
        $(this).toggleClass('open');
        $('.site-header-content').toggleClass('open');
        $("body").toggleClass("modal-open");
    });

    $('.confort-espaces-menu a').click(function(e){
        e.preventDefault();

        $('.confort-espaces-menu a').removeClass('active');
        $(this).addClass('active');

        var selector = $(this).attr('href');
        $('.confort-espace').removeClass("active");
        $('.confort-espace'+selector).addClass("active");

        $('.confort-espace'+selector).get(0).scrollIntoView();

    });

    $('.consultations-menu a').click(function(e){
        e.preventDefault();

        var $link = $(this);
        $('.consultations-menu a').not($link).parent().removeClass('active');
        $link.parents().addClass('active');

        var href = $link.attr('href');
        $('.consultations-right .consultation').hide();

        $('.consultations-right .consultation'+href).show();

    });

    $('.univi-upload .forminator-file-upload').each(function(indx, elem){


        if( $(elem).find('.btn-upload-input-clear').length==0 ){
            $(elem).prepend('<div class="btn-upload-input-clear">Annuler</div>');
        }

        if( $(elem).find('.btn-upload-input-title').length==0 ){
            $(elem).prepend('<div class="btn-upload-input-title">Choisir un fichier</div>');
        }

        var btnTitle = $(".btn-upload-input-title").html();
        var btnTitleHtml = $.parseHTML(btnTitle);

        $(elem).find("input:file").on('change', function (){
           console.log("im clicked" + this.files.length);
           if( this.files && this.files.length >= 1 ) {
              var file = this.files[0];
                 var reader = new FileReader();
                 // Set preview image into the popover data-content
                 reader.onload = function (e) {
                    $(elem).addClass('file-choosed')
                    $(elem).find(".btn-upload-input-title").text(file.name);
                 }
                 reader.readAsDataURL(file);
           }else {
                $(elem).removeClass('file-choosed');
                $(elem).find(".btn-upload-input-title").html(btnTitle);
           }
             
         }); 

         $(elem).on('click', '.btn-upload-input-clear', function(e){
            e.preventDefault();
            $(elem).find("input:file").val('').trigger('change'); 
            $(elem).removeClass('file-choosed');
            $(elem).find(".btn-upload-input-title").html(btnTitle);
         });


    });

});


import { LeafletMap } from './map.js';

if( document.getElementById('contact_map') ){
    var map = new LeafletMap('contact_map');

    $.ajax({
        url: themeajax.ajaxurl,
        type: "POST",
        dataType:'json',
        data: {
            action: "univi_contact_map_ajax_action"
        }

    }).done(function(response) {

        //console.log(response);

        let marker = map.addMarker([response.lat, response.lng], response.html, 'purple');

        marker.popup.options.maxWidth = 240;

        map.setOpenMarker(marker);
        marker.marker.openPopup();

        map.setCenter([response.lat, response.lng], 15);

    });
    
}

if( document.getElementById('univi-generic-map') ){

    var $mapElem = document.getElementById('univi-generic-map');
    var map = new LeafletMap('univi-generic-map');

    var pageId = $mapElem.getAttribute('data-pageid');
    var acfAddressField = $mapElem.getAttribute('data-addressfield');
    var popupTitle = $mapElem.getAttribute('data-popuptitle');

    $.ajax({
        url: themeajax.ajaxurl,
        type: "POST",
        dataType:'json',
        data: {
            action: "univi_generic_map_ajax_action",
            pageId: pageId,
            acfAddressField: acfAddressField,
            popupTitle: popupTitle
        }

    }).done(function(response) {

        //console.log(response);

        let marker = map.addMarker([response.lat, response.lng], response.html, 'purple');

        marker.popup.options.maxWidth = 240;

        map.setOpenMarker(marker);
        marker.marker.openPopup();

        map.setCenter([response.lat, response.lng], 15);

    });
    
}